import { IOEEFormProducts } from "../../../MachineCenterCreationFormInterfaces";

export const T_PREFIX = "corporate_backoffice.production_line_view.machine_center_creation_form";

export enum OEE_INPUT_METHOD {
    TIME_BASED = 1,
    COUNT_BASED = 2,
    SPEED_BASED = 3,
}

export type ProductKey = number | string;

export const VALUE_LABEL_BY_METHOD: Record<number, string> = {
    [OEE_INPUT_METHOD.TIME_BASED]: `${T_PREFIX}.oee_product_ideal_cycle_time`,
    [OEE_INPUT_METHOD.COUNT_BASED]: `${T_PREFIX}.oee_product_ideal_cycle_time`,
    [OEE_INPUT_METHOD.SPEED_BASED]: `${T_PREFIX}.oee_product_rated_speed`,
};

export interface ProductListProps {
    products: IOEEFormProducts[];
    setFieldValue: (field: string, value: unknown) => void;
    disabled: boolean;
    t: (key: string) => string;
    selectedMethodId: number | "";
}
